import React, { useState } from 'react'
import { Link } from "gatsby"
import Fade from 'react-reveal/Fade'
import he from 'he'
import BoughtLogo from '../assets/images/bought-white.svg'

const BoughtPropertyCard = ({url, imageSource, title, specs, price, testimonial, weblink}) => {
  return (
    <section className="property-card">
      <Link to={weblink} className="property-card__inner">
        <div className="property-card__top">
          <picture>
            <img src={imageSource} alt={title} key={title} />
          </picture>
          { !testimonial && <img className="sold bought_card-logo" src={BoughtLogo} alt="Bought"/> }
        </div>
        <div className="property-card__bottom">
          <h6>{ he.decode(title) }</h6>
          <ul>
            { specs.bed && <li>{ specs.bed } Beds</li> }
            { specs.bath && <li>{ specs.bath } Bath</li> }
            { specs.car && <li>{ specs.car } Car</li> }
          </ul>
          <div className="property-card__cost">{ price }</div>
        </div>
      </Link>
    </section>
  )
}

const AgentBought = ({ bought }) => {
  const [columns, setColumns] = useState("four-col")

  return (
    <>
      <div className='property-blocks__heading agent-bought__heading'>
        <h4>Bought Properties</h4>
      </div>
      <section className='property-blocks agent-bought' data-color='#ffffff'>
        <div className='property-blocks__inner'>
          <div className={'property-blocks__list ' + columns}>
            <Fade bottom distance='50px' duration={500}>
              { bought?.length > 0 ? bought?.map((item, index) => {
                return (
                  <BoughtPropertyCard
                    key={index}
                    url={"/" + item.slug}
                    imageSource={item.acf.featuredImage?.localFile?.publicURL}
                    title={item.title}
                    specs={item.acf.specs}
                    price={item.acf.price}
                    testimonial={item.acf.testimonial}
                    weblink={item.acf.weblink ? item.acf.weblink : '/'}
                  />)
              }) : <p style={{ textAlign: 'center', width: '100%' }}>No properties found</p> }
            </Fade>
          </div>
        </div>
      </section>
    </>
  )
}

export default AgentBought